import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type ISoundSettings } from '@/types/ISoundSettings';
import {
  readSoundSettings,
  saveSoundSettings
} from '@/services/sound/soundSettingsStorage';

const initialState: ISoundSettings = readSoundSettings();

const soundSettings = createSlice({
  name: 'soundSettings',
  initialState,
  reducers: {
    setSoundEnabled(state, action: PayloadAction<boolean>) {
      state.enabled = action.payload;
      saveSoundSettings(state);
    },
    setSoundId(state, action: PayloadAction<string>) {
      state.soundId = action.payload;
      saveSoundSettings(state);
    },
    setSoundVolume(state, action: PayloadAction<number>) {
      state.volume = Math.min(1, Math.max(0, action.payload));
      saveSoundSettings(state);
    }
  }
});

export const { setSoundEnabled, setSoundId, setSoundVolume } =
  soundSettings.actions;

export default soundSettings.reducer;
